module.exports = __webpack_public_path__ + "img/xcg1.3550e08a.png";